module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/633b86695a4c4660ea61a22765eb9a7f.png";